import { Component, Input, OnChanges, OnDestroy, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';

import { Subscription } from 'rxjs';

import { commonContants } from '../../constants/common.contants';
import { CityModelComponent } from '../city-model/city-model.component';
import { SharedService } from '../../services/shared.service';
import { GlobalContants } from '../../constants/global.contants';
import { MatRegisterIconService } from '../../services/mat-register-icon.service';
import { UserService } from '../../services/user.service';
import FileSaver from 'file-saver';
import { ReportService } from 'src/app/reports/services/report.service';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy, OnChanges {

  @Input("IsLoggedIn") isLoggedIn: boolean = false;
  // @ViewChild(MatMenuTrigger) menuTrigger!: MatMenuTrigger;
  langset: string = commonContants.defaultLanguage;
  selectedCity: string = '';
  globalContants = GlobalContants.Routes;
  userInfo: any;
  citySub$: Subscription = new Subscription();
  userSub$: Subscription = new Subscription();
  cityLang!: string;
  placeCode: string='';
  currentLangID=1;
  cityFlag: any='';
  headerHide: boolean = false;
  downloading!: boolean;
  constructor(
    private dialog: MatDialog,
    private sharedService: SharedService,
    private s: MatRegisterIconService,
    private userService: UserService,
    private router: Router,
    private route: ActivatedRoute,
    private reportService : ReportService
  ){}

  ngOnInit(): void {

    this.getSelectedCity();
    this.getCitylist();
    this.userInfo = this.sharedService.getStoreValue(GlobalContants.StoreKey.userInfo);
    this.getUserInfo();
    this.getChangedLang();
    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {
        const url = document.location.pathname;
        this.headerHide = url === '' || url === '/';
        this.closeOverlayBackdrop();
      }
    });
  }

  getChangedLang(){
    this.sharedService.language$.subscribe(res=>{
      this.closeOverlayBackdrop();
      let language = this.sharedService.getCurrentLangID();
      this.currentLangID = language;
      this.userInfo = {...this.sharedService.getStoreValue(GlobalContants.StoreKey.userInfo)};
      if(this.userInfo && this.userInfo?.user_details){
        let f = this.userInfo?.user_details[language]?.first_name ? this.userInfo?.user_details[language]?.first_name?.trim() : this.userInfo?.user_details[1]?.first_name.trim()
        let l = this.userInfo?.user_details[language]?.last_name ? this.userInfo?.user_details[language]?.last_name?.trim() : this.userInfo?.user_details[1]?.last_name.trim()
        this.userInfo['uname'] =  f+ " " +l
      }else{
        this.userInfo['uname'] = '';
      }
    })
  }

  /**
   * On language change and router change close the all mat popup, menu, and select option vy clicking overlay backdrop
   */
  closeOverlayBackdrop() {
    const backdrop = document.querySelector('.cdk-overlay-backdrop');
    if (backdrop) {
      (backdrop as HTMLElement).click();
    }
  }

  ngOnChanges(changes: SimpleChanges): void{
    if(changes['isLoggedIn'] && changes['isLoggedIn'].currentValue){
      this.getSelectedCity();
      this.userInfo = this.sharedService.getStoreValue(GlobalContants.StoreKey.userInfo);
      this.getUserInfo();
      this.getChangedLang();
    }

  }


  getCitylist(): void{
    this.citySub$ = this.sharedService.selectedCity$.subscribe((res: any) => {
      this.getSelectedCity();
    })
  }

  getUserInfo(): void{
    this.userSub$ = this.sharedService.userInfo$.subscribe((res: any) => {
      this.userInfo = this.sharedService.getStoreValue(GlobalContants.StoreKey.userInfo);
    });
  }

  openCityModel(): void{
    const dialogRef = this.dialog.open(CityModelComponent, {
      maxWidth: '95vw',
      maxHeight: '97vh',
      width: '618px',
       panelClass: 'custom-model-container'
    })

    dialogRef.afterClosed().subscribe((result: any) => {
      if(result && result.selectedCity){
        this.selectedCity = result.selectedCity.place_name
      }
    });
  }

  getSelectedCity(): void{
    this.selectedCity = this.sharedService.getStoreValue(GlobalContants.StoreKey.PlaceName);
    this.placeCode = this.sharedService.getStoreValue(GlobalContants.StoreKey.placeCode);
    this.cityFlag = this.sharedService.getStoreValue(GlobalContants.StoreKey.CityFlag);
    this.placeCode = this.placeCode ? this.placeCode.toLowerCase():'';
    this.cityLang = `${this.sharedService.CityLang}`;
  }

  logout(): void{
    this.userService.userLogout();
  }


  downloadPdfChartView(){

    let qpamar:any={};
     this.route.queryParams.subscribe((param: any) => {
        qpamar = { ...param }
      })
      qpamar['report_type']='multi_story_residential';
       this.downloading =true;
    this.reportService.downloadPdfChartView(qpamar).subscribe({
        next: (data: any) => {
           this.downloading =false;
            if (data.body) {
            const blob = new Blob([data.body], { type: 'application/pdf' })
            FileSaver.saveAs(blob, `Property Report - ${new Date().getTime()}.pdf`)
          }
        }, error: () => {
          this.downloading =false;
        }
      })
  }
  ngOnDestroy(): void{
    this.citySub$?.unsubscribe();
    this.userSub$?.unsubscribe();
  }

}
